/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FeatureIdPayload = {
    featureId: FeatureIdPayload.featureId;
};
export namespace FeatureIdPayload {
    export enum featureId {
        DOCUMENTATION = 'documentation',
        PAYMENTS = 'payments',
        ACCOUNTING = 'accounting',
        EXTERNAL_CALENDARS = 'externalCalendars',
        ONLINE_MEETINGS = 'onlineMeetings',
        EMAIL_CUSTOMIZATION = 'emailCustomization',
        SEMINARS = 'seminars',
        FORMS = 'forms',
    }
}

